import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FLink, Table, TableMobile, Button, Datepicker } from '@components';
import { currency } from '@utils';
import { useSelector } from 'react-redux';

import { addDays, format } from 'date-fns';
import { CONTRATOS_ABSOLUTE_PATH } from '../../../../../common/utils/paths';
import { EmprestimoService } from '../../../../../common/services/emprestimo';

const service = new EmprestimoService();

export const Carencia = () => {
  const { id } = useParams();
  const location = useLocation();
  const {
    vlrSolicitado,
    parcTotal,
    parcPagas,
    ultimaParcela,
    vlrSaldoDevedor,
    totalParcelasEmAtraso,
    valorTotalEmAtraso,
  } = location.state;

  const navigate = useNavigate();
  const {
    matricula,
    token,
    dadosPessoais: { email },
  } = useSelector((state) => state.user);

  const [dataPagamento, setDataPagamento] = useState(new Date());
  const [dataFormatada, setDataFormatada] = useState('');

  const [valor, setValor] = useState('');

  useEffect(() => {
    setDataFormatada(format(dataPagamento, 'yyyy-MM-dd'));
  }, [dataPagamento]);

  const calculaQtParcelas = useCallback(() => {
    return 12 - parcPagas;
  }, [parcPagas]);

  useEffect(() => {
    if (parcTotal > 12) {
      service
        .obterCalcularAntecipacaoCarencia({
          contrato: id,
          matricula,
          parcela: calculaQtParcelas(),
          token,
        })
        .then((res) => setValor(res));
    }
  }, [id, matricula, parcPagas, parcTotal, calculaQtParcelas, token]);

  const existeBoletoParaReemissao = false;

  const valorEmCentavos = (valor * 100).toFixed(0);

  const geraBoletoCarencia = () => {
    service
      .emitirBoletoEmprestimo({
        matricula,
        email,
        numeroContrato: id,
        token,
        dataVencimento: dataFormatada,
        valor: valorEmCentavos,
        tipoPagamento: 'Antecipação de Carência',
      })
      .then((res) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Boleto Antecipação de Carência - ${matricula}.PDF`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  };

  return (
    <div className="card">
      <div className="card-body">
        <FLink
          className="justify-content-start mb-32"
          iconLeft="icon-arrow_back"
          onClick={() => navigate(CONTRATOS_ABSOLUTE_PATH)}
        >
          voltar
        </FLink>
        <h3 className="ts-20 fw-bold text-black mb-2">
          Antecipação de carência do contrato: {id}
        </h3>

        {parcTotal <= 12 ? (
          <p>
            Para solicitar o BOLETO e regularizar a sua situação entre em
            contato com à Forluz através da{' '}
            <a
              target="_blank"
              href="https://forluz.neoassist.com/?th=tag_vforluzfixa&openEmail=true&mainCategory=emprestimo&subCategory=pagamentos&subCategory2=521056"
              rel="noreferrer"
            >
              Central de Atendimento
            </a>{' '}
            ou pelo telefone 0800.090.9090.
          </p>
        ) : (
          <>
            <Table
              large
              odd
              className="is-desktop mb-32"
              columns={[
                'Valor',
                'Parcelas',
                'Lançadas',
                'Última',
                'Saldo devedor',
                'Atrasadas',
                'Valor em atraso',
              ]}
            >
              <tr>
                <td className="ts-20">{currency(vlrSolicitado)}</td>
                <td className="ts-20">{parcTotal}</td>
                <td className="ts-20">{parcPagas}</td>
                <td className="ts-20">{currency(ultimaParcela)}</td>
                <td className="ts-20">{currency(vlrSaldoDevedor)}</td>
                <td className="ts-20">{totalParcelasEmAtraso}</td>
                <td className="ts-20">{currency(valorTotalEmAtraso)}</td>
              </tr>
            </Table>

            <TableMobile className="mb-32">
              <div className="col-6">
                <div className="thead">Valor</div>
                <div className="td">{currency(vlrSolicitado)}</div>
              </div>
              <div className="col-6">
                <div className="thead">Parcelas</div>
                <div className="td">{parcTotal}</div>
              </div>
              <div className="col-6">
                <div className="thead">Lançadas</div>
                <div className="td">{parcPagas}</div>
              </div>
              <div className="col-6">
                <div className="thead">Última</div>
                <div className="td">{currency(ultimaParcela)}</div>
              </div>
              <div className="col-6">
                <div className="thead">Saldo devedor</div>
                <div className="td">{currency(vlrSaldoDevedor)}</div>
              </div>
              <div className="col-6">
                <div className="thead">Atrasadas</div>
                <div className="td">{totalParcelasEmAtraso}</div>
              </div>
              <div className="col-12">
                <div className="thead">Valor em atraso</div>
                <div className="td">{currency(valorTotalEmAtraso)}</div>
              </div>
            </TableMobile>

            {existeBoletoParaReemissao && (
              <div>
                <p>
                  Já existe um boleto com data de emissão dd/mm/yyyy em aberto
                  para esse contrato. Para reemiti-lo utilize o botão abaixo:
                </p>
                <div className="d-flex gap-4 align-items-end mt-3">
                  <Button className="w-250">Reemitir boleto</Button>
                </div>
              </div>
            )}

            <div>
              <p className="my-32">Informe os dados dessa simulação:</p>
              <Table
                large
                className="is-desktop mb-32"
                columns={['Quantidade de parcelas carência', 'Valor']}
              >
                <tr>
                  <td className="ts-20">{calculaQtParcelas()}</td>
                  <td className="ts-20">{currency(valor)}</td>
                </tr>
              </Table>
              <TableMobile className="mb-32">
                <div className="col-6">
                  <div className="thead">Quantidade de parcelas carência</div>
                  <div className="td">{calculaQtParcelas()}</div>
                </div>
                <div className="col-6">
                  <div className="thead">Valor</div>
                  <div className="td">{currency(valor)}</div>
                </div>
              </TableMobile>
            </div>

            <div className="col-12 col-md-3 col-lg-3">
              <Datepicker
                label="Data de pagamento"
                value={dataPagamento}
                min={new Date()}
                max={addDays(new Date(), 1)}
                onChange={setDataPagamento}
              />
            </div>

            <div className="card-footer">
              <hr className="mb-32" />
              <div className="row">
                <div className="col-12 col-sm-6 col-md-4 ms-0 ms-sm-auto">
                  <Button
                    onClick={geraBoletoCarencia}
                    transparent
                    color="orange"
                  >
                    Gerar boleto
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
